import React, { useState } from 'react'
import { withRouter } from "react-router"
import { Formik, Form } from 'formik'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import FormMovieDataTabContainer from '../../containers/forms/FormMovieDataTabContainer'
// import * as Yup from 'yup';
import {
    INFORMATION,
    IMAGES,
    ATTRIBUTES,
    PLAYTIMES
} from '../../constants/tabTypes'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import Translation from '../Translation/cont/Translation'
import movieAttrToSourceAttr from '../../functions/movieAttrToSourceAttr'

const FormMovieData = ({
    movieData,
    metaData, 
    sourceData, 
    sourceDataProvider, 
    onUpdateExtension, 
    onResetExtension,
    sourceMoviesByItemId, 
    performances, 
    attributes, 
    closePagePath, 
    history, 
    onUpdateItem,
    movieExtensionsItems, 
    movieExtensionsToReset,
    cliMovieRelevantSourceMovies, 
    onChangeField, 
    onResetField
}) => {
    // const validationSchema = () => {
    //     Yup.object().shape({
    //     movie: Yup.object({
    //         displayDates: Yup.object({
    //             start: Yup.date(),
    //             end: Yup.date()
    //                 .min(yup.ref('start'), 'Liegt vor dem Startdatum')
    //           }),
    //       }),
    //     // title: Yup.string()
    //     //     .required('Dieses Feld wird benötigt!'),
    //     // movieId: Yup.string()
    //     //     .required('Es muss ein Film ausgewählt werden!'),
    // });}

    const [movieImages, setMovieImages] = useState([])

    const setMovieImageValues = (images, values) => {
        const imagesCopy = []
        let ambient = ''
        let backgrounds = []

        images.map((img, index) => {
            imagesCopy.push({...img})
            delete imagesCopy[index].itemId
        })

        if(images.length > 0) {
            ambient = imagesCopy.shift()
        } 

        if(images.length > 1) {
            backgrounds = imagesCopy
        }

        values.movie.images.ambient = ambient
        values.movie.images.backgrounds = backgrounds
    }

    return (
        <Formik
            initialValues={
                sanitizeFormInput({
                    movie: movieData,
                    attributes: attributes,
                    performances: performances,
                    movieExtensionsItems: movieExtensionsItems,
                    cliMovieRelevantSourceMovies: cliMovieRelevantSourceMovies,
                    movieExtensionsEdited: [],
                    movieExtensionsReset: movieExtensionsToReset,
                    sourceMoviesByItemId: sourceMoviesByItemId
                })
            }
            onSubmit={(values, actions) => {
                if(0 !== movieImages.length) {
                    setMovieImageValues(movieImages, values)
                }

                if(0 !== values.movieExtensionsEdited.length) {
                    values.movieExtensionsEdited.map(movieExtensionsItemKey => {
                        const currentMovieExtensionsItem = values.movieExtensionsItems[movieExtensionsItemKey]
                        if(currentMovieExtensionsItem.technologyAttributes !== '') {
                            onUpdateExtension(movieExtensionsItemKey, 'technologyAttributes', currentMovieExtensionsItem.technologyAttributes)
                        } 
                        if(currentMovieExtensionsItem.alternateLink !== '') {
                            onUpdateExtension(movieExtensionsItemKey, 'alternateLink', currentMovieExtensionsItem.alternateLink)
                        } else {
                            onResetExtension(movieExtensionsItemKey, 'alternateLink')
                        }
                    })
                }

                if(0 !== values.movieExtensionsReset.length) {
                    values.movieExtensionsReset.map(movieExtensionsItemKey => {
                        if(!movieExtensionsToReset.includes(movieExtensionsItemKey)) {
                            onResetExtension(movieExtensionsItemKey, 'technologyAttributes')
                        }
                    })
                }

                onUpdateItem(sanitizeFormOutput(values), metaData)
                actions.setSubmitting(false)
                history.push(closePagePath)
            }}
            // validationSchema={validationSchema}
            onReset={(values, actions) => {
                history.push(closePagePath)
            }}>
            {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue, handleChange }) => {
                const onChange = key => e => {
                    handleChange(e)
                    onChangeField(key)
                }
                
                const onReset = (key) => {
                    const sourceKey = movieAttrToSourceAttr(key, sourceDataProvider)
                    const sourceValue = sourceData[sourceKey] ? _.isArray(sourceData[sourceKey]) ? sourceData[sourceKey][0] : sourceData[sourceKey] : ""
                    setFieldValue('movie.' + key, sourceValue)
                    onResetField(key)
                }

                return (
                <Form
                className='moviedata-form'>
                    <FormMovieDataTabContainer
                        defaultTab={INFORMATION}
                        values={values}
                        setFieldValue={setFieldValue}
                        metaData={metaData}
                        setMovieImages={setMovieImages}
                        onChange={onChange}
                        handleChange={handleChange}
                        onReset={onReset}
                        tabs={[
                            {
                                "title": <Translation id="movie_edit_tab_information"/>,
                                "id": INFORMATION
                            },
                            {
                                "title": <Translation id="movie_edit_tab_movie_series" />,
                                "id": ATTRIBUTES
                            },
                            {
                                "title": <Translation id="movie_edit_tab_movie_times" />,
                                "id": PLAYTIMES
                            },
                            {
                                "title": <Translation id="movie_edit_tab_movie_images" />,
                                "id": IMAGES
                            }
                        ]}
                    >
                    </FormMovieDataTabContainer>

                    <ButtonSubmitCancel
                        transIdCancel="cancel_button"
                        transIdSubmit="save_movie_button"
                        disabledCancel={isSubmitting}
                        disabledSubmit={isSubmitting}
                        onCancel={handleReset}
                    />

                </Form>
            )}}
        </Formik>
    )
}

export default withRouter(FormMovieData)